// tslint:disable
export var TCSEligibilityStatus;
(function (TCSEligibilityStatus) {
    // Unknown
    TCSEligibilityStatus[TCSEligibilityStatus["Unknown"] = -1] = "Unknown";
    // Member number valid, but patient ineligible at this time
    TCSEligibilityStatus[TCSEligibilityStatus["PatientIneligible"] = 0] = "PatientIneligible";
    // Eligible pending survey data
    TCSEligibilityStatus[TCSEligibilityStatus["EligiblePending"] = 1] = "EligiblePending";
    // Pending enrollment
    TCSEligibilityStatus[TCSEligibilityStatus["PendingEnrollment"] = 2] = "PendingEnrollment";
    // Member number invalid
    TCSEligibilityStatus[TCSEligibilityStatus["MemberNumberInvalid"] = 3] = "MemberNumberInvalid";
    // Activation period expired
    TCSEligibilityStatus[TCSEligibilityStatus["ActivationPeriodExpired"] = 4] = "ActivationPeriodExpired";
    // Ready to activate
    TCSEligibilityStatus[TCSEligibilityStatus["ReadyToActivate"] = 5] = "ReadyToActivate";
    // Transfer to TrialCard
    TCSEligibilityStatus[TCSEligibilityStatus["TransferToTrialcard"] = 6] = "TransferToTrialcard";
})(TCSEligibilityStatus || (TCSEligibilityStatus = {}));
TCSEligibilityStatus['UNKNOWN'] = -1;
TCSEligibilityStatus['PATIENTINELIGIBLE'] = 0;
TCSEligibilityStatus['ELIGIBLEPENDING'] = 1;
TCSEligibilityStatus['PENDINGENROLLMENT'] = 2;
TCSEligibilityStatus['MEMBERNUMBERINVALID'] = 3;
TCSEligibilityStatus['ACTIVATIONPERIODEXPIRED'] = 4;
TCSEligibilityStatus['READYTOACTIVATE'] = 5;
TCSEligibilityStatus['TRANSFERTOTRIALCARD'] = 6;
//# sourceMappingURL=TCSEligibilityStatus.js.map